"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { trackAction } from "./trackActions";
import type { ExternalTrackingActions } from "./events/validEventNames";
interface ExternalTrackingBeaconPayload extends CustomEvent {
  type: "external_tracking";
  detail: {
    name: (typeof ExternalTrackingActions)[number];
    data: object;
  };
}
export const ExternalTrackingBeacon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
};
function _temp(evt) {
  trackAction(evt.detail.name, evt.detail.data, {
    ga: true,
    datalake: true,
    exp: false,
    posthog: true,
    vercel: false
  });
}
function _temp2() {
  const handleEvent = _temp;
  const wrappedHandler = e => handleEvent(e as ExternalTrackingBeaconPayload);
  window?.addEventListener?.("external_tracking", wrappedHandler);
  return () => window?.removeEventListener?.("external_tracking", wrappedHandler);
}